export default __webpack_public_path__ + "static/TravelAd-0fca6f24be88623e29fe3feec3960583.png";